var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-detail"},[(_vm.stock)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.stock.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }